// External Dependencies:
import ReactGA from 'react-ga'

// Internal Dependencies:
import { doRequest } from 'utilities/request'

var passiveSupported = false;

try {
	var options = Object.defineProperty( {}, 'passive', {
		get: function() {
			passiveSupported = true
		}
	})

	window.addEventListener( 'test', null, options )
} catch( err ) {}

function disableTouchScroll( e ) {
	e.preventDefault()
}

export function openSearch() {
	return {
		type: 'OPEN_SEARCH'
	}
}

export function closeSearch() {
	return {
		type: 'CLOSE_SEARCH'
	}
}

export function searchActionDo( value ) {
	return {
		type: 'SEARCH',
		value
	}
}

export function searchAction( value ) {
	return function( dispatch, getState ) {
		const { isOpen } = getState().search

		dispatch( searchActionDo( value ) )
	}
}

export function submitSearch() {
	return { type: 'SUBMIT_SEARCH' }
}

export function setFilters( value ) {
	return {
		type: 'SET_FILTERS',
		value
	}
}

// export function setMixedResultsState( value ) {
// 	return {
// 		type: 'SET_MIXED_RESULTS_STATE',
// 		value
// 	}
// }

export function hoverMapMarker( data ) {
	return {
		type: 'HOVER_MAP_MARKER',
		data
	}
}

export function selectMapMarker( data ) {
	return {
		type: 'SELECT_MAP_MARKER',
		data
	}
}

export function setMapBounds( bounds, center, zoom ) {
	return {
		type: 'SET_MAP_BOUNDS',
		data: {
			bounds: bounds,
			center: center,
			zoom: zoom
		}
	}
}

export function setAllowMapOverride( data ) {
	return {
		type: 'SET_ALLOW_MAP_OVERRIDE',
		data
	}
}

export function googleMapsApiLoading() {
	return {
		type: 'MAPS_API_LOADING'
	}
}

export function googleMapsApiLoaded() {
	return {
		type: 'MAPS_API_LOADED'
	}
}

export function toggleMapDetails() {
	return {
		type: 'TOGGLE_MAP_DETAILS'
	}
}

export function clearMapDetails() {
	return {
		type: 'CLEAR_MAP_DETAILS'
	}
}

export function searchLoading() {
	return { type: 'SEARCH_LOADING' }
}

export function requestingSearchData() {
	return { type: 'REQUESTING_SEARCH_DATA' }
}

export function requestingPlaceData() {
	return { type: 'REQUESTING_PLACE_DATA' }
}

export function receiveSearchData( json, args ) {
	return {
		type: 'RECEIVE_SEARCH_DATA',
		data: json,
		args: args
	}
}

export function receivePlaceData( uuid, json ) {
	return {
		type: 'RECEIVE_PLACE_DATA',
		uuid: uuid,
		data: json
	}
}

export function receiveError( json ) {
	return {
		type: 'RECEIVE_ERROR',
		data: json
	}
}

export function requestCurrentPosition() {
	return function( dispatch, getState ) {
		if ( navigator.geolocation ) {
			navigator.geolocation.getCurrentPosition( ( pos ) => {
				const latLng = {
					lat: pos.coords.latitude,
					lng: pos.coords.longitude
				};

				dispatch( setAllowMapOverride( true ) )
				dispatch( setCurrentPosition( latLng ) )
				dispatch( getSearchData() )
			});
		}
	}
}

export function setCurrentPosition( latLng ) {
	return {
		type: 'SET_CURRENT_POSITION',
		latLng
	}
}

export function getSearchData( searchTerm = false, args = false ) {
	return function( dispatch, getState ) {
		const { allowMapOverride } = getState().search

		if ( ! searchTerm ) {
			searchTerm = getState().search.searchTerm
		}

		if ( searchTerm.length <= 1 ) {
			return
		}

		dispatch( requestingSearchData() )

		const { searchResults, userLatLng, bounds, map_center, zoom, filters, filtersChanged } = getState().search
		var additionalArgs = ''

		if ( ! args ) {
			args = {
				blockUI: true
			}
		}

		if ( args.blockUI ) {
			dispatch( searchLoading() )
		}

		if ( searchResults.request_user_location && navigator.geolocation ) {
			dispatch( requestCurrentPosition() )
		}

		// send the current map bounds, unless the map state is being overriden
		if ( bounds && ! allowMapOverride ) {
			let b = bounds

			let n = '&bounds_n=' + b.north
			let e = '&bounds_e=' + b.east
			let s = '&bounds_s=' + b.south
			let w = '&bounds_w=' + b.west
			additionalArgs += n + e + s + w
		}

		if ( userLatLng ) {
			let { lat, lng } = userLatLng
			let userLocation = '&user_lat=' + lat + '&user_lng=' + lng

			additionalArgs += userLocation
		}

		if ( map_center ) {
			additionalArgs += '&map_center=' + map_center.lat + ',' + map_center.lng
		}

		if ( zoom ) {
			additionalArgs += '&zoom=' + zoom
		}

		var filtersList = []

		if ( filters ) {
			Object.keys( filters ).map( ( key ) => {
				if ( filters[ key ] ) {
					filtersList.push( key )
				}
			} )

			filtersList.join( ',' )
			additionalArgs += '&filters=' + filtersList
		}

		if ( filtersChanged ) {
			additionalArgs += '&filters_changed=true'
		}

		return doRequest( `${siteData.search_api_base_url}all?search_term=${searchTerm}&referrer=${siteData.current_site_slug}${additionalArgs}` )
			.then( json => {
				dispatch( receiveSearchData( json, args ) )

				// ensure that when causing a new search by panning or zooming the map,
				// the response doesn't override/set the state of the map
				// (eg. map center, zoom)
				dispatch( setAllowMapOverride( false ) )

				if ( json.map_markers && json.map_markers.length == 1 ) {
					dispatch( getPlaceData( json.map_markers[0].uuid ) )
				}

				// send Google Analytics event:
				if ( 'production' === process.env.NODE_ENV ) {
					ReactGA.event({
						category: 'Search',
						action: searchTerm
					});
				}
			})
			.catch( error => {
				console.log( error, 'error' );
			})
	}
}

export function getPlaceData( uuid = false ) {
	return function( dispatch, getState ) {
		const { placeById, isRequestingPlaceData } = getState().search

		if ( isRequestingPlaceData ) {
			return
		}

		// Try to get the item:
		if ( placeById[ uuid ] ) {
			return placeById[ uuid ]
		}

		dispatch( requestingPlaceData() )

		return doRequest( `${siteData.search_api_base_url}place/${uuid}` )
			.then( json => {
				dispatch( receivePlaceData( uuid, json ) )
			})
			.catch( error => {
				console.log( error, 'error' );
			})
	}
}



// WEBPACK FOOTER //
// ./redux/actions/search.jsx